<template>
  <div class="popup-holder">
    <PopupContent
      ref="lampstatus"
      :x="location[0]"
      :y="location[1]"
      :assetId="assetId"
      :address="address"
      :status="status"
      :objectId="objectId"
      :globalId="globalId"
      :owner="owner"
      :ean="ean"
      :view="view"
    />
  </div>
</template>
<script lang="js">
import Vue from "vue";
import PopupContent from "../components/PopupContent.vue";
import MapView from "@arcgis/core/views/MapView";
import * as _ from "underscore";
import Point from "@arcgis/core/geometry/Point";
import Graphic from "@arcgis/core/Graphic";
import { Config } from "@/config";
import { SpatialReference, Extent } from "@arcgis/core/geometry";
import { MELDING_STATUS } from "../enums/melding-status";
import { eventBus } from "../event-bus";
import { isServiceUser } from '../utils';
/* eslint-disable */ 
export default Vue.extend({
  name: "PopupHolder",
  components: { PopupContent },
  props: {
    view: {
      type: MapView,
      required: true,
    },
    scale: {
      type: Number,
    },
  },
  data: function () {
    return {
      assetId: 0,
      status: null,
      location: [],
      address: null,
      firstLoad: true, // HACK due to loading of popup. At the first load the popup visiblity is changing to visbile=false, so at first load it has to be checked
      objectId: null,
      globalId: null,
      owner: '',
      ean: ''
    };
  },
  methods: {
    showPopup(refArmatur) {      
      let notificationLayer = this.view.map.findLayerById("notification-layer");
      let query = notificationLayer.createQuery();
      let expandBy = Config.ext.notificationToleranceHit;
      query.geometry = refArmatur.geometry;
      query.geometry = new Extent({
        xmin: refArmatur.geometry.x - expandBy,
        xmax: refArmatur.geometry.x + expandBy,
        ymin: refArmatur.geometry.y - expandBy,
        ymax: refArmatur.geometry.y + expandBy,
        spatialReference: { wkid: 25833 },
      }); // the point location of the pointer
      query.spatialRelationship = "intersects"; // this is the default
      query.returnGeometry = true;
      let inStatuses = [
        MELDING_STATUS.REGISTERED,
        MELDING_STATUS.JOB_CREATED_NOT_DELEGATED,
        MELDING_STATUS.JOB_ONGOING,
        MELDING_STATUS.JOB_ON_HOLD,
        MELDING_STATUS.JOB_ASSIGNED
      ]
        .map((status) => "'" + status + "'")
        .join(",");
      query.where = `STATUS IN (${inStatuses})`;
      query.outFields = ["STATUS", "OBJECTID"];
      notificationLayer.queryFeatures(query).then((response) => {
        let notifications = response.features;
        let armaturNotifications = notifications.filter((g) => {
          return (
            g.geometry.x >= refArmatur.geometry.x - expandBy &&
            g.geometry.x <= refArmatur.geometry.x + expandBy &&
            g.geometry.y >= refArmatur.geometry.y - expandBy &&
            g.geometry.y <= refArmatur.geometry.y + expandBy
          );
        });
        
        if (armaturNotifications.length > 1) {
          let notificationsOids = armaturNotifications.map((n) => {
            return n.attributes["OBJECTID"];
          });
          console.error(
            `There are more notifications on armatur OID: ${refArmatur.attributes.OBJECTID} (x,y)=>(${refArmatur.geometry.x},${refArmatur.geometry.y}). Notifications: ${notificationsOids}. The first one returned will be taken.`
          );
        }
        if (armaturNotifications.length !== 0) {
          // notifications exists
          this.status = armaturNotifications.sort((a, b) => a.attributes.OBJECTID - b.attributes.OBJECTID)[0].getAttribute("STATUS");
        } else {
          this.status = null;
        }
        let srcAddress = refArmatur.getAttribute("VED_ADRESSE");
        console.log(refArmatur); 
        
        let address =
          srcAddress !== null && srcAddress !== ""
            ? srcAddress.substring(0, srcAddress.indexOf("Avstand")).trim()
            : null;
        this.address = address;
        this.location = [refArmatur.geometry.x, refArmatur.geometry.y];
        this.assetId = refArmatur.getAttribute("ASSETID");
        this.objectId = refArmatur.getAttribute("OBJECTID");
        this.globalId = refArmatur.getAttribute("GLOBALID");
        this.owner = refArmatur.getAttribute("KUNDE");
        this.ean = refArmatur.getAttribute("EAN_NR");
      });
    },
  },
  created: function () {
    eventBus.$on("foundNearestLamp", (graphics) => {
      this.showPopup(graphics);
    });
    eventBus.$on("faultFormChanged", (faultForm) => {
      if (faultForm === null) {
        this.view.popup.close();
      }
    });
    this.view.popup.close();
    this.view.popup = {
      autoOpenEnabled: false,
      dockOptions: {
        buttonEnabled: false,
      },
      collapseEnabled: false,
      actions: [],
      visibleElements: {
        closeButton: false,
      },
    };
    //TODO control popup visiblity only with location. In genergal, control popup visibility in one way. Now it is controlled (opened, closed) with map view or with popup holder conpoment.
    this.view.popup.watch("visible", (visible) => {
      eventBus.$emit("popupVisible", visible);
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      } // HACK check property define
      if (visible === false) {
        this.address = null;
        this.location = [];
        this.assetId = 0;
      }
    });
    this.view.on("click", (event) => {
      this.view.popup.fetchFeatures(event.screenPoint).then((response) => {
        response.allGraphicsPromise.then((graphics) => {

          if (graphics.length === 0) {
            this.address = null;
            this.location = [];
            this.assetId = 0;
            return;
          }

          let armaturs = (!isServiceUser()) 
                            ? graphics.filter((g) => g.layer.id === "lamps-layer")
                            : graphics.filter((g) => g.layer.id === "owners-layer");
  
          let groupedByCoord = _.groupBy(armaturs, function (g) {
            return `${g.geometry.x} ${g.geometry.y}`;
          });
          if (Object.keys(groupedByCoord).length > 1) {
            if (this.view.zoom !== Config.ext.mapconfig.maxZoom) {
              this.$buefy.toast.open({
                duration: 5000,
                message: this.$t("zoomInToReportFault"),
                position: "is-bottom",
                type: "is-danger",
              });
              return;
            }
            console.warn(
              `There are more armaturs ${
                Object.keys(groupedByCoord).length
              } on one click, taking the first one.`
            );
          }
          let selectedArmatur = groupedByCoord[Object.keys(groupedByCoord)[0]];
          if (selectedArmatur.length > 1) {
            console.warn(
              `On that aramtur there are more lamps (bulbs) (${selectedArmatur.length}) on one place. Taking the one with LOWEST ASSETID`
            );
          } // there are more lamps (bulbs) on one place, so take the lamp with the lowest ASSETID because
          let refArmatur = selectedArmatur.sort((a, b) =>
            a.getAttribute("ASSETID") > b.getAttribute("ASSETID") ? 1 : -1
          )[0]; //--------------- // check notifications on armatur
          this.showPopup(refArmatur);
        });
      });
    });
  },
  watch: {
    location: function (newVal) {
      let me = this;
      if (newVal && newVal[0] && newVal[1]) {
        this.view.popup.open({
          location: new Point({
            x: newVal[0],
            y: newVal[1],
            spatialReference: new SpatialReference({ wkid: 25833 }),
          }), // event.mapPoint,
        content: this.$refs.lampstatus.$el, //htmlElement
        title: "", // title text 'Search result' keeps also on search result popup, so it needs to be explicitly removed, since title is created by html content
        includeDefaultActions: false
        });
        let marker = {
          type: "simple-marker",
          outline: { cap: "square", width: 3, color: [255, 255, 255, 1] },
          size: 16,
          color: [255, 255, 255, 0],
        };
        let pointHighlight = new Graphic({
          geometry: new Point({
            x: newVal[0],
            y: newVal[1],
            spatialReference: { wkid: 25833 },
          }),
          symbol: marker,
        });
        this.view.graphics.removeAll();
        this.view.graphics.add(pointHighlight);
      } else {
        eventBus.$emit("faultFormChanged", null);
        this.view.graphics.removeAll();
        me.view.popup.close();
      }
    },
  },
});
</script>
<style scoped></style>
